import { z } from 'zod';
import { badgeTypeDTO } from './badgeTypeDTO';

export const reviewDTO = z.object({
    id: z.string(),
    title: z.string().nullish(),
    body: z.string().nullish(),
    userName: z.string().nullish(),
    rating: z.number(),
    createdAt: z.string(),
    contextualData: z
        .array(
            z.object({
                id: z.enum(['Gender', 'Age', 'ExperienceDachat']),
                value: z.string(),
                label: z.string(),
            }),
        )
        .optional(),
    isRecommended: z.boolean(),
    locale: z.string().nullish(),
    loyaltyStatus: z.enum(['PRE_ACHAT', 'WHITE', 'BLACK', 'GOLD', 'STANDARD', 'STAR', 'NONE']),
    badge: badgeTypeDTO,
    helpfulness: z.object({
        positiveCount: z.number(),
        negativeCount: z.number(),
    }),
    syndication: z
        .object({
            name: z.string().nullish(),
            imageUrl: z.string().nullish(),
            url: z.string().nullish(),
        })
        .nullish(),
});
export type reviewDTO = z.infer<typeof reviewDTO>;

export const RatingsAndReviewsDTO = z.object({
    count: z.number(),
    filters: z.array(
        z.object({
            id: z.string(),
            type: z.string(),
            refinements: z
                .array(
                    z.object({
                        id: z.string(),
                        count: z.number(),
                    }),
                )
                .default([]),
        }),
    ),
    sorting: z.array(
        z.object({
            id: z.string(),
            label: z.string(),
        }),
    ),
    reviews: z.array(reviewDTO),
    distribution: z
        .array(
            z.object({
                rating: z.number(),
                count: z.number(),
            }),
        )
        .default([]),
});
export type RatingsAndReviewsDTO = z.infer<typeof RatingsAndReviewsDTO>;
